<template>

    <card>
        <card-header>
            <card-title>
                <translate>laufende Anfragen</translate>
            </card-title>
        </card-header>
        <card-content>
            <table class="table table--stripped table--td-top">
                <thead>
                <tr>
                    <th><translate>PF-Nr</translate></th>
                    <th><translate>Projekttitel</translate></th>
                    <th class="text-center"><translate>Zeichnung</translate></th>
                    <th class="text-right"><translate>Stück</translate></th>
                    <th class="text-right"><translate>Wunschliefertermin</translate></th>
                    <th class="text-right"><translate>verschickte Anfragen</translate></th>
                    <th class="text-right"><translate>erhaltene Angebote</translate></th>
                    <th class="text-right"><translate>Angebot vsl. bis</translate></th>
                    <th class="text-right"><translate>erstellt am</translate></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="askForQuote in askForQuotesTable" :key="askForQuote.index">
                    <td>
                        <Link :href="this.$$route('component', {'askForQuote':askForQuote.id})">{{ askForQuote.pfnumber }}</Link>
                    </td>
                    <td>{{ askForQuote.project_name }}</td>
                    <td class="text-center">
                        <file-download :sketch-file="askForQuote.client_sketch_file" v-if="askForQuote.client_sketch_file"/>
                        <file-download :cad-file="askForQuote.client_cad_file" v-if="askForQuote.client_cad_file"/>
                    </td>
                    <td class="text-right" v-html="askForQuote.lot_qty"></td>
                    <td class="text-right">{{ askForQuote.delivery_wish_string }}</td>
                    <td class="text-right">{{ askForQuote.bid_round_members_count }}</td>
                    <td class="text-right">{{ askForQuote.bid_round_member_offers_count }}</td>
                    <td class="text-right">{{ askForQuote.bid_round_ending_at_string }}</td>
                    <td class="text-right">{{ askForQuote.created_at_string }}</td>
                </tr>
                <tr v-if="noAskForQuotes">
                    <td colspan="10" class="text-center">
                        <strong>
                            <translate>keine Einträge vorhanden</translate>
                        </strong>
                    </td>
                </tr>
                </tbody>
            </table>
        </card-content>
    </card>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardContent from '@partfactory/Shared/Card/CardContent';
import CardTitle from '@partfactory/Shared/Card/CardTitle';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import FileDownload from '@partfactory/Shared/Elements/FileDownload';

export default {
    name: 'DashboardRunningAskForQuotes',
    components: {FileDownload, CardHeader, CardTitle, CardContent, Card},
    props: {
        runningAskForQuotes: Object,
    },
    computed: {
        noAskForQuotes() {
            return this.runningAskForQuotes.length === 0;
        },
        askForQuotesTable() {
            let askForQuotes = Array;

            return Object.keys(this.runningAskForQuotes).map(key => {
                askForQuotes[key] = this.runningAskForQuotes[key];

                // askForQuotes[key].lot_qty = askForQuotes[key].client_order.client_offer.amount;
                let lotQty = [];
                lotQty.push(askForQuotes[key].lotqty_1, askForQuotes[key].lotqty_2, askForQuotes[key].lotqty_3, askForQuotes[key].lotqty_4);
                askForQuotes[key].lot_qty = lotQty.filter(lot => lot !== null).join('<br>');

                askForQuotes[key].created_at_string = this.$date(askForQuotes[key]?.created_at_string);

                askForQuotes[key].bid_round_ending_at_string = askForQuotes[key]?.bid_rounds[0]?.ending_at ? this.$date(askForQuotes[key]?.bid_rounds[0]?.ending_at) : '';

                askForQuotes[key].delivery_wish_string = askForQuotes[key].delivery_date ? this.$date(askForQuotes[key].delivery_date) : 'k.A.';

                return askForQuotes[key];
            });
        },
    },
};
</script>
